package fr.manyverse.app.presentation.components

import androidx.compose.runtime.Composable
import fr.manyverse.app.AppLogger
import fr.manyverse.app.domain.error.UnreadableImageError
import fr.manyverse.app.domain.model.ImageData
import fr.manyverse.app.infrastructure.imagepicker.rememberPlatformImagePickerLauncher
import fr.manyverse.app.presentation.error.UserErrorNotifier
import org.koin.mp.KoinPlatform

private const val TAG = "ImagePicker"

/**
 * Ouvre le sélecteur d'image de la plateforme et rend l'image choisie à [onPicked].
 *
 * Une annulation ne fait rien. Un fichier que la plateforme n'a pas su lire ou convertir est
 * signalé à l'utilisateur en snackbar (choisir une autre image) et remonté à Sentry : le
 * sélecteur ne propose que des images, un échec révèle un cas que l'app ne sait pas lire.
 * Seule l'exception est loggée, jamais le nom du fichier.
 */
@Composable
fun rememberImagePickerLauncher(onPicked: (ImageData) -> Unit): () -> Unit {
    return rememberPlatformImagePickerLauncher(
        onPicked = onPicked,
        onFailure = { error ->
            AppLogger.error(TAG, "Image choisie illisible", error)
            // Résolu à l'échec seulement : les tests d'écran affichent ce sélecteur sans Koin
            KoinPlatform.getKoin().get<UserErrorNotifier>().notify(UnreadableImageError(error))
        }
    )
}
